module.exports = __webpack_public_path__ + "img/tips1_img7.0775ffd3.jpg";